<main class="datasets">
  <app-dataset-preview
    [showToolbar]="true"
    [showButtonGroup]="false"
  ></app-dataset-preview>
</main>
